import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Record$dUnsafe from "../Record.Unsafe/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dWeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
const fixRecord = dict => dict.fixRecord;
const fixFRPRecordNil = dictTypeEquals => {
  const to = dictTypeEquals.proof(a => a);
  return {
    fixRecord: dictMonadFRP => {
      const map = dictMonadFRP.MonadCleanup1().Monad0().Bind1().Apply0().Functor0().map;
      return v => f => map(Data$dTuple.snd)(f(to({})));
    }
  };
};
const fixFRPRecord = dictFixFRPRecord => () => ({fixFRP: dictMonadFRP => dictFixFRPRecord.fixRecord(dictMonadFRP)(Type$dProxy.Proxy)});
const fixFRP = dict => dict.fixFRP;
const fixFRPRecordCons = dictIsSymbol => () => () => () => () => dictFixFRP => dictFixFRPRecord => (
  {
    fixRecord: dictMonadFRP => {
      const fixFRP2 = dictFixFRP.fixFRP(dictMonadFRP);
      const fixRecord2 = dictFixFRPRecord.fixRecord(dictMonadFRP);
      const Monad0 = dictMonadFRP.MonadCleanup1().Monad0();
      const bind = Monad0.Bind1().bind;
      const pure = Monad0.Applicative0().pure;
      return v => f => fixFRP2(v1 => fixRecord2(Type$dProxy.Proxy)(v2 => bind(f(Record$dUnsafe.unsafeSet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(v1)(v2)))(v3 => pure(Data$dTuple.$Tuple(
        Record$dUnsafe.unsafeDelete(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(v3._1),
        Data$dTuple.$Tuple(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(v3._1), v3._2)
      )))));
    }
  }
);
const fixFRP_ = dictFixFRP => dictMonadFRP => {
  const fixFRP2 = dictFixFRP.fixFRP(dictMonadFRP);
  const map = dictMonadFRP.MonadCleanup1().Monad0().Bind1().Apply0().Functor0().map;
  return f => fixFRP2(input => map(x => Data$dTuple.$Tuple(x, undefined))(f(input)));
};
const fixEvent = dictMonadFRP => {
  const MonadCleanup1 = dictMonadFRP.MonadCleanup1();
  const Monad0 = MonadCleanup1.Monad0();
  const Bind1 = Monad0.Bind1();
  const MonadEffect0 = dictMonadFRP.MonadEffect0();
  const newEvent = Specular$dFRP$dBase.newEvent(MonadEffect0);
  const subscribeEvent_ = Specular$dFRP$dBase.subscribeNode(MonadEffect0)(MonadCleanup1);
  const pure = Monad0.Applicative0().pure;
  return f => Bind1.bind(newEvent)(v => {
    const $0 = v.fire;
    return Bind1.bind(f(v.event))(v1 => {
      const $1 = v1._2;
      return Bind1.bind(subscribeEvent_($0)(v1._1))(() => pure($1));
    });
  });
};
const fixFRPEvent = {fixFRP: dictMonadFRP => fixEvent(dictMonadFRP)};
const fixDyn = dictMonadFRP => {
  const Monad0 = dictMonadFRP.MonadCleanup1().Monad0();
  const Bind1 = Monad0.Bind1();
  const newEvent = Specular$dFRP$dBase.newEvent(dictMonadFRP.MonadEffect0());
  const holdWeakDyn = Specular$dFRP$dWeakDynamic.holdWeakDyn(dictMonadFRP);
  const subscribeDyn_ = Specular$dFRP$dBase.subscribeDyn_(dictMonadFRP);
  const pure = Monad0.Applicative0().pure;
  return f => Bind1.bind(newEvent)(v => {
    const $0 = v.fire;
    return Bind1.bind(holdWeakDyn(v.event))(wdyn => Bind1.bind(f(wdyn))(v1 => {
      const $1 = v1._2;
      return Bind1.bind(subscribeDyn_($0)(v1._1))(() => pure($1));
    }));
  });
};
const fixFRPDynamic = {fixFRP: dictMonadFRP => fixDyn(dictMonadFRP)};
export {fixDyn, fixEvent, fixFRP, fixFRPDynamic, fixFRPEvent, fixFRPRecord, fixFRPRecordCons, fixFRPRecordNil, fixFRP_, fixRecord};
